export default "__VITE_ASSET__CRgOF8u6__"